export const TRANSPORT_TYPE_GET_REQUEST = 'TRANSPORT_TYPE_GET_REQUEST';
export const TRANSPORT_TYPE_GET_SUCCESS = 'TRANSPORT_TYPE_GET_SUCCESS';
export const TRANSPORT_TYPE_GET_ERROR = 'TRANSPORT_TYPE_GET_ERROR';
export const TRANSPORT_TYPE_GET_BY_KEY_REQUEST = 'TRANSPORT_TYPE_GET_BY_KEY_REQUEST';
export const TRANSPORT_TYPE_GET_BY_KEY_SUCCESS = 'TRANSPORT_TYPE_GET_BY_KEY_SUCCESS';
export const TRANSPORT_TYPE_GET_BY_KEY_ERROR = 'TRANSPORT_TYPE_GET_BY_KEY_ERROR';
export const TRANSPORT_TYPE_ADD_REQUEST = 'TRANSPORT_TYPE_ADD_REQUEST';
export const TRANSPORT_TYPE_ADD_SUCCESS = 'TRANSPORT_TYPE_ADD_SUCCESS';
export const TRANSPORT_TYPE_ADD_ERROR = 'TRANSPORT_TYPE_ADD_ERROR';
export const TRANSPORT_TYPE_EDIT_REQUEST = 'TRANSPORT_TYPE_EDIT_REQUEST';
export const TRANSPORT_TYPE_EDIT_SUCCESS = 'TRANSPORT_TYPE_EDIT_SUCCESS';
export const TRANSPORT_TYPE_EDIT_ERROR = 'TRANSPORT_TYPE_EDIT_ERROR';
export const TRANSPORT_TYPE_DELETE_REQUEST = 'TRANSPORT_TYPE_DELETE_REQUEST';
export const TRANSPORT_TYPE_DELETE_SUCCESS = 'TRANSPORT_TYPE_DELETE_SUCCESS';
export const TRANSPORT_TYPE_DELETE_ERROR = 'TRANSPORT_TYPE_DELETE_ERROR';
